import { Pipe, PipeTransform } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { selectRentalById } from '../stores'

@Pipe({
  name: 'rentalName',
})
export class RentalNamePipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform(rentalId: string): Observable<string> {
    return this.store.pipe(
      select(selectRentalById(rentalId)),
      map((rental) => rental?.nickname || rental?.name || '')
    )
  }
}
